import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import RequestedItems from './RequestedItems';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, error, message, requestedItems, totalPage, currentPage,
  } = state.market;
  return {
    isLoading,
    error,
    message,
    requestedItems,
    totalPage,
    currentPage,
  };
}

const Styled = withStyles(styles)(RequestedItems);

export default connect(
  mapStateToProps,
)(Styled);
